import type { SensitivityType } from "./factor-sensitivity/types"
import type { TemplateChartSettings } from "connected-components/dashboard/store/template-chart-settings"
import { type DataStatus, ERROR, LOADING, OK } from "helpers/data-statuses"

// Per-template chart-settings keys + defaults. Every graph template defaults selectedCategory to "total".

export const GRAPH_RISK_TEMPLATE_KEY = "risk"
export const GRAPH_PERFORMANCE_TEMPLATE_KEY = "performance"
export const GRAPH_EXPOSURE_TEMPLATE_KEY = "exposure"
export const GRAPH_CONTENT_SET_TEMPLATE_KEY = "content-set"

export const GRAPH_CUSTOM_TEMPLATE_TYPE = "dashboard-custom-graph"

export const CONTENT_SET_TEMPLATE_PREFIX = "content-set-"

export const EMPTY_CUSTOM_TEMPLATES: readonly never[] = []

export function gateCustomTemplatesResult<T>(
  rawTemplates: T[] | null | undefined,
  isFeatureEnabled: boolean,
): T[] | null | undefined | typeof EMPTY_CUSTOM_TEMPLATES {
  return isFeatureEnabled ? rawTemplates : EMPTY_CUSTOM_TEMPLATES
}

export function gateCustomTemplatesStatus(
  rawStatus: DataStatus,
  isFeatureEnabled: boolean,
  isFeatureResolved: boolean,
  isFeatureLoadFailed: boolean,
): DataStatus {
  if (isFeatureEnabled) return rawStatus
  if (isFeatureLoadFailed) return ERROR
  return isFeatureResolved ? OK : LOADING
}

// Predicted and historical factor sensitivity persisted independently (was two preference subtypes).
export const graphFactorSensitivityTemplateKey = (sensitivityType: SensitivityType): string =>
  `factor-sensitivity-${sensitivityType}`

export const GRAPH_CATEGORY_DEFAULTS: TemplateChartSettings = { selectedCategory: "total" }
